import $ from 'jquery';

import contentTemplate from 'properties/style/mouse_over.ejs';
import { pickerCfg } from 'pickerCfg.js';
import themeService from 'ThemeService.js';
import BasePropertyView from 'BasePropertyView.js'
import util from 'util/Util.js';
import listService from 'ListService';
import constants        from 'Constants';

class StyleMouseOverView extends BasePropertyView {

    initialize(opts) {
        super.initialize(opts);
        this.options = opts || {};
        this.template = contentTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'blur input[type=text]': 'lostFocus',
            'focus input[type=text]': 'getFocus',
            'change input[type=color]': 'updateColorAttributes',
            'change input[type=text]': 'updateColorAttributesWithValidation',
            'keydown #styleColorTextOver': 'keyAction'
        };

        let mobileDesignerStyle = listService.mainKind === constants.KIND_MOBILE ? "display: none;" : "";
        this.model.set('mobileDesignerStyle', mobileDesignerStyle, constants.MODEL_SILENT);
        
        return this;
    }

    keyAction(ev) {
        var code = ev.keyCode || ev.which;
        if (code === 13) {
            ev.preventDefault();
        }
    }

    render() {
        super.render();
        let props = this.resolveThemeColors(this.model, ['styleColorText', 'styleColorTextOver']);
        this.$el.html(this.template(props));

        //.$('input[type=color]', this.$el).spectrum(pickerCfg);

        this.delegateEvents();

        return this;
    }

}

export default StyleMouseOverView;
